import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialShipmentState } from '../../Models';

export const shipmentSlice = createSlice({
  name: "shipment",
  initialState: initialShipmentState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setPostCodeCheckLoading: (state, action: PayloadAction<boolean>) => {
      state.postCodeCheckLoading = action.payload
    },
    setShipmentNumber: (state, action: PayloadAction<string>) => {
      state.shipmentNumber = action.payload;
      state.postCode = '';
    },
    setPostCode: (state, action: PayloadAction<string>) => {
      state.postCode = action.payload
    },
  },
});

export const { setLoading, setPostCodeCheckLoading, setShipmentNumber, setPostCode } = shipmentSlice.actions